import React, { Component } from 'react';
import '../../../styles/global.scss';
import {Popup} from 'semantic-ui-react';
import MonthlyUnitLineChart from "./monthly-unit-line-chart";
import {UtilityColors} from "../constants/chart-color-constants";
import PropTypes from "prop-types";
import { withRouter } from 'react-router-dom';


const defaultUnits = [
    { field: "gas", label: "Gas", color: UtilityColors.gas },
    { field: "electricity", label: "Electricity", color: UtilityColors.electricity },
    { field: "water", label: "Water", color: UtilityColors.water }
];

/**
 * Conventional chart that wraps up common utility conventions for the monthly unit chart
 * This will always display gas/elec/water each month
 * @extends Component
 */
class MonthlyUtilityChart extends Component {
    constructor(props) {
        super(props);

        this.state = {
            units: this.generateUnits(props.data)
        }
    }

    generateUnits(data) {
        const unitsToUse = [...defaultUnits];

        if (!data[0] || !data[0].water) { unitsToUse.splice(2,1); }
        if (!data[0] || !data[0].electricity) { unitsToUse.splice(1,1); }
        if (!data[0] || !data[0].gas) { unitsToUse.splice(0,1); }

        return unitsToUse;
    }

   

    componentDidUpdate(prevProps) {



        // Check if data prop has changed
        if (this.props.data !== prevProps.data) {
            // If so, regenerate units based on the new data
            this.setState({
                units: this.generateUnits(this.props.data)
            });
        }
    }

    render() {
        return (
                <Popup
                trigger={
                    <MonthlyUnitLineChart data={this.props.data} units={this.state.units} title={this.props.title} label={this.props.label}   history={this.props.history} 
                    defaultUtility={this.props.defaultUtility} // Pass the defaultUtility prop
                    onElementsClick={this.props.onElementsClick}
                    selectedRowKey={this.props.selectedRowKey}
                    size={this.props.size}
                    />
                }
                content=""
                position="top center"
                inverted
                />
            
        )
    }
}

MonthlyUtilityChart.propTypes = {
    data: PropTypes.arrayOf(PropTypes.shape({
        date: PropTypes.any.isRequired,
        gas: PropTypes.oneOfType([ PropTypes.string, PropTypes.number ]),
        electricity: PropTypes.oneOfType([ PropTypes.string, PropTypes.number ]),
        water: PropTypes.oneOfType([ PropTypes.string, PropTypes.number ]),
    })),
    title: PropTypes.string,
    label: PropTypes.string,
    defaultUtility: PropTypes.string, // Add defaultUtility prop type
    onElementsClick : PropTypes.any,
    selectedRowKey : PropTypes.string,
    size: PropTypes.oneOf(["small","compress", "medium", "large"]),

};
export default withRouter(MonthlyUtilityChart);